import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=799db851&scoped=true"
import script from "./PromoCard.vue?vue&type=script&lang=js"
export * from "./PromoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799db851",
  null
  
)

export default component.exports